export default {
  general: {
    loading: 'Carregando',
    understood: 'Entendi',
    attention: 'Atenção!',
    edit: 'Editar',
    save: 'Salvar',
    delete: 'Excluir',
    cancel: 'Cancelar',
    abandon: 'Abandonar',
    proceed: 'Prosseguir',
    editInformation: 'Editar Informações',
    editLocation: 'Editar Localização',
    editDetail: 'Editar Detalhes',
    editValue: 'Editar Valores',
    whoops: 'Ops...',
    verified: 'Verificado',
    negotiates: 'Negocia',
    return: 'Retornar',
    rent: 'Aluguel',
    dueDate: 'Vencimento',
    condominium: 'Condomínio',
    iptu: 'IPTU',
    sectionTitles: {
      location: 'Localização',
      propertyDetails: 'Detalhes do Imóvel',
      condominiumDetails: 'Detalhes do Condomínio',
      responsible: 'Responsável',
      propertyValues: 'Valores do Imóvel',
    },
    mainTabs: {
      rent: 'Alugar',
      announcement: 'Anunciar',
      manage: 'Administrar',
      profile: 'Perfil',
    },
    formErrors: {
      missingField: 'O campo {{missingField}} é obrigatório.',
    },
    seeProfile: 'Visualizar Perfil',
    deniedCredit: 'Crédito negado',
    seeOffer: 'Visualizar Proposta',
    month: {
      jan: 'Jan',
      feb: 'Fev',
      mar: 'Mar',
      apr: 'Apr',
      may: 'Mai',
      jun: 'Jun',
      jul: 'Jul',
      aug: 'Ago',
      sep: 'Set',
      oct: 'Out',
      nov: 'Nov',
      dec: 'Dez',
    },
    months: {
      zero: 'meses',
      one: 'mês',
      other: 'meses',
    },
    years: {
      zero: 'anos',
      one: 'ano',
      other: 'anos',
    },
    contact: 'Tirar Dúvidas',
    moment: {
      fullDate: 'DD MM YYYY',
    },
    error: 'Ocorreu um erro! ',
    technicalDetails: 'Detalhes Técnicos: ',
  },
  report: {
    irregularities: 'Irregularidades neste anúncio?',
    button: 'Denunciar',
  },
  shared: {
    profileView: {
      commonFriendsTitle: 'Amigos em comum',
      commonFriendsSubtitle: 'Vocês possuem amizades em comum.',
      commonInterestsTitle: 'Interesses',
      commonInterestsSubtitle: 'Vocês possuem interesses em comum.',
      socialMediaTitle: 'Redes Sociais',
      socialMediaSubtitle: 'Confira as principais redes sociais deste usuário',
      contact:
        'Caso tenha interesse em entrar em contato com {{userName}} é só acessar seus contatos.',
    },
  },
  helpers: {
    image: {
      options: {
        takePhoto: 'Tirar Foto',
        pickFromGallery: 'Escolher da Galeria',
      },
      cameraAndGalleryDenied:
        'A permissão para o uso da câmera e/ou galeira foi negada. ' +
        'Para usar essa funcionalidade, por favor acesse as preferências do sistema e habilite essa permissão.',
    },
    announcement: {
      alertLandlord:
        'Infelizmente não foi possível entrar em contato com esse inquilino ' +
        'pois o mesmo não informou um número de Whatsapp.',
      alertRent:
        'Infelizmente não foi possível entrar em contato com esse locador ' +
        'pois o mesmo não informou um número de Whatsapp.',
      wppLinkingError:
        'Não foi possíve abrir o Whatsapp. Certifique-se de que o aplicativo se encontra ' +
        'instalado e tente novamente mais tarde.',
    },
  },
  conditions: {
    header: 'Condições',
    mainText:
      'As condições para negócio são estabelecidas pelo proprietário e podem estar abertas a negociação.',
    bankDeposit: 'Depósito Bancário',
    insuranceBond: 'Seguro Fiança',
  },
  components: {
    detailRowProperty: 'Detalhes do Imóvel',
    propertyOwner: 'Dono(a) do Imóvel',
    infoRowHouse: 'casa',
    infoRowType: 'tipo',
    infoRowArea: 'área',
    infoRowBathrooms: 'banheiros',
    infoRowRooms: 'quartos',
    infoRowGarage: 'garagem',
    valuesRowRent: 'Aluguel',
    valuesRowCondominium: 'Condominio',
    valuesRowIPTU: 'IPTU',
    valuesRowOthers: 'Outros',
    valuesTotal: 'total:',
    noConnection: 'Sem Conexão com a Internet',
    noConnectionOffline:
      'O sistema está offline, por favor confira sua conexão com a internet e tente novamente',
    noConnectionButton: 'Tentar Novamente',
    announcementMapSummary: {
      apartment: 'Apartamento',
      house: 'Casa',
      studio: 'Kitnet/Studio',
      rentValue: 'Aluguel',
      totalValue: 'Total',
    },
    propertyDetail: {
      penthouseApartment: 'Apartamento com cobertura',
      cabinetsInTheKitchen: 'Armários na cozinha',
      cabinetsInTheBathroom: 'Armários no banheiro',
      airConditioning: 'Ar Condicionado',
      whirlpoolBathtub: 'Banheira de hidromassagem',
      serviceBathroom: 'Banheiro de serviço',
      stove: 'Fogão Incluso',
      refrigeratorIncluded: 'Geladeira inclusa',
      garden: 'Jardim',
      gourmetBalcony: 'Varanda gourmet',
      serviceRoom: 'Quarto de Serviço',
      pool: 'Piscina',
      barbecue: 'Churrasqueira',
      petFriendly: 'Aceita animais',
      extraReversibleRoom: 'Quarto extra reversível',
      glassBox: 'Box de Vidro',
      gasShower: 'Chuveiro à Gás',
      bedroomCloset: 'Armário nos Quartos',
      bed: 'Cama',
      sofa: 'Sofá',
      washingMachine: 'Máquina de lavar',
      decoratedProperty: 'Imóvel decorado',
    },
    condominiumDetail: {
      gym: 'Academia',
      barbecue: 'Churrasqueira',
      elevator: 'Elevador',
      gourmetSpace: 'Espaço Gourmet na área comum',
      laundry: 'Lavanderia no prédio',
      pool: 'Piscina',
      playground: 'Playground',
      concierge: 'Portaria 24h',
      sportsCourt: 'Quadra Esportiva',
      partyHall: 'Salão de Festas',
      sauna: 'Sauna',
    },
    propertyType: {
      title: 'Tipo de Propriedade',
      house: 'Casa',
      apartment: 'Apê',
      studio: 'Kitnet/Studio',
    },
  },
  tutorial: {
    announcement: {
      title: 'Ao cadastrar seu imóvel no Mellro:',
      firstText: 'Você cria um anúncio de graça e recebe notificações dos interessados',
      secondText:
        'Você pode ver o perfil dos interessados e ' +
        'selecionar com mais segurança o inquilino dos seus sonhos',
      thirdText:
        'Você pode conversar, negociar e entrar em contato com o seu futuro inquilino por Whatsapp',
    },
    catalog: {
      firstTitle: 'Nosso Catálogo é fácil de usar!',
      firstText:
        'Ao arrastar para direita você curte o imóvel, e com um arrastar para a esquerda você remove ' +
        'ele da sua lista! Fácil não é mesmo?!',
      secondTitle: 'Nosso Catálogo é fácil de usar!',
      secondText:
        'Com um simples Toque na imagem do imóvel você consegue ver todas as fotos contidas no ' +
        'cartão do imóvel.',
      thirdTitle: 'Você também pode buscar pelo mapa!',
      thirdText: 'Você pode buscar imóveis por região rapidinho através da busca por Mapa.',
      fourthTitle: 'Ou se preferir também tem lista',
      fourthText: 'Prefere buscar em lista? Sem problema, também temos esta opção pra você!',
      fifthTitle: 'Curtiu um imóvel?',
      fifthText:
        'Agora é só esperar o dono do imóvel aprovar o seu perfil para começar as negociações.',
      buttonText: 'Ir para a busca',
    },
    manageOwner: {
      firstTitle: 'Administre seus pagamentos e contratos',
      firstText: 'Permite que você possa acompanhar o pagamento dos alugueis.',
      secondTitle: 'Descontos e Acréscimos',
      secondText: 'E você também pode adicionar novas condições nas parcelas em aberto.',
      thirdTitle: 'Direto com o Morador',
      thirdText: 'Você pode entrar em contato com seu morador para tirar dúvidas.',
    },
    manageTenant: {
      firstTitle: 'Administre seus pagamentos e contratos',
      firstText:
        'Permite que você possa acompanhar os alugueis, efetuar pagamentos e gerenciar o contrato.',
      thirdTitle: 'Direto com o Dono',
      thirdText: 'Você pode entrar em contato com o dono para tirar dúvidas.',
    },
    help: {
      title: 'Precisa de mais ajuda?',
      text: 'Se ainda estiver com dúvidas dê um alô que a gente te ajuda!',
      button: 'Pedir ajuda',
    },
  },
  announcement: {
    registerMyProperty: 'Anunciar meu imóvel',
    buttonText: 'Próximo',
    photoUpload: {
      multipleUploadClose: 'Cancelar',
      multipleUploadDone: 'Finalizar',
      multipleUploadSelected: 'Selecionado(s)',
      multipleUploadEmpty: 'Sua galeria está vazia',
      multipleUploadPick: 'Escolher Múltiplas Fotos',
      alertText:
        'As permissões para a câmera e/ou galeria de fotos foram negada(s). ' +
        'Para criar anúncios, acesse as preferências do sistema e habilite essas permissões.',
      titleText: 'Adicionar Fotos',
      subtitleText: 'Adicione as fotos que irão compor o anúncio do seu imóvel',
      highlight: 'Destaque',
    },
    propertyAddress: {
      autocomplete: {
        address: 'Endereço',
        placeholder: 'Informe o Endereço',
      },
      titleText: 'Endereço do Imóvel',
      subtitleText: 'Insira a localização do imóvel que deseja anunciar',
      invalidZipcode: 'O CEP está incompleto.',
      invalidState: 'A UF está incompleta.',
      invalidAddress:
        'Não foi possível encontrar o local no mapa. Por favor, revise os dados de endereço informados.',
      zipCode: 'CEP',
      zipCodePlaceholder: 'Insira o CEP do imóvel',
      city: 'Cidade',
      state: 'UF',
      neighbourhood: 'Bairro',
      street: 'Logradouro',
      number: 'Numero',
      numberPlaceholder: 'Número do Imóvel',
      complement: 'Complemento',
      complementPlaceholder: 'Apto/Bloco/Casa',
    },
    propertyRefPoint: {
      refPoint: 'Ponto de Referência',
      refPointPlaceholder: 'Insira um ponto de referência próximo ao imóvel',
    },
    propertyDetail: {
      titleText: 'Detalhes do Imóvel',
      subtitleText: 'Detalhar seu imóvel aumenta as chances de alugar',
    },
    condominiumDetail: {
      titleText: 'Detalhes do Condomínio',
      subtitleText: 'Detalhar seu imóvel aumenta as chances de alugar',
    },
    propertyInfo: {
      titleText: 'Informações do Imóvel',
      subtitleText: 'Defina as características do seu imóvel',
      typeText: 'Tipo',
      areaText: 'Área total do imóvel',
      roomText: 'Quarto(s)',
      bathroomText: 'Banheiro(s)',
      carSlotText: 'Vaga(s)',
    },
    propertyValues: {
      titleText: 'Valores do Imóvel',
      subtitleText: 'Descreva os valores que compõem o valor final para locação de seu imóvel',
      switchText: 'O INQUILINO PAGA',
      placeholders: {
        rent: 'Insira o valor do aluguel',
        condominium: 'Insira o valor do seu condominio',
        iptu: 'Insira o valor do seu IPTU',
        others: 'Insira o valor do item personalizado',
      },
      labels: {
        labelRent: 'Aluguel',
        labelCondominium: 'Condominio',
        labelIPTU: 'IPTU Mensal',
        labelOthers: 'Outros',
      },
      rentZeroText: 'O valor do aluguel não pode ser zero!',
      totalValueText: 'Valor Total',
    },
    propertyConditions: {
      title: 'Garantia',
      moreDetail: 'Mais Detalhes',
      likeThat: 'Anúnciado fica assim:',
      youGetMonthMoney: 'Você fica todo o mes com:',
      titleText: 'Selecione uma opção para o modelo de garantia de seu contrato e pagamento!',
      bottomText: 'Não se preocupe, você pode alterar sua garantia para cada interessado!',
      component: {
        year: 'ANO',
        creditalApprove: 'Depende da aprovação de crédito!',
        financialInsurance: 'SEGURO FIANÇA',
        withBill: 'COM BOLETO',
        noGuarantor: 'Não precisa de fiador',
      },
      depositBond: {
        title: 'CAUÇÃO DE ENTRADA',
        ManualReceipt: 'Recibo Manual',
        bankBillet: 'Sem Boleto',
        monthsToDeposit: 'Até 3 meses para deposito',
        legalCovarage: 'Sem cobertura legal',
        chargeBy: ' A cobrança é feita pelo dono',
        assistance: 'Sem assistência',
        comission: 'Sem comissão',
        threeMonths: '03 MESES',
        twoMonths: '03 MESES',
        oneMonth: '01 MES',
        noDeposit: 'SEM CAUÇÃO',
        guarantee: 'Sem garantia de recebimento',
        selectMonth: {
          title: 'Selecione quantos cauções equivalente ao valor do aluguel',
          subtitle: 'N° de cauções',
          button: 'Confirmar e continuar',
        },
      },
      insuranceBond: {
        title: 'SEGURO INCLUSO',
        automaticReceipt: 'Recibo Automatico',
        bankBillet: 'Com Boleto*',
        insurancePercent: '15% de Seguro pagos pelo morador',
        legalCovarage: 'Com cobertura Jurídica*',
        chargeBy: 'A seguradora cobra em caso de atraso',
        assistance: 'Assistência 24h para emergências',
        comission: 'Sem taxas, sem comissão',
        guarantor: 'Não precisa de fiador',
        guarantee: '30 meses de recebimento garantido de aluguel, condominio, IPTU e outros*',
      },
      conditionDetails: {
        mellroAdvantagesTitle: 'VANTAGENS MELLRO',
        finalValue: 'ValorFinal',
        numbers: {
          one: '01',
          two: '02',
          three: '03',
          four: '04',
          five: '05',
          six: '06',
          seven: '07',
          eight: '08',
          nine: '09',
          thirty: '30',
        },
        depositBond: {
          subtitle:
            'Caução é uma forma de garantia em contratos que envolvam valores monetários para assegurar' +
            'o pagamento ao fornecedor. Nesse caso, o objeto de caução nada mais ' +
            'é que a garantia do cumprimento de uma obrigação ou contrato. ' +
            'O seu objetivo em um contrato de aluguéis é diminuir o risco de não pagamento por parte do locatário. ' +
            'Logo, na quebra de contrato de aluguel com caução, o garantia é acionada e o dono do imóvel é restituído.',
          howWorks: 'COMO FUNCIONA?',
          canAsk: ' Você pode pedir até:',
          depositMonths: 'meses de caução',
          legalCovarage: 'Sem cobertura legal',
          chargeBy: ' A cobrança é feita pelo dono',
          assistance: 'Sem assistência',
          comission: 'Sem comissão',
          threeMonths: '03 MESES',
          guarantee: 'Sem garantia de recebimento',
          mellroAdvantages: {
            subtitle: 'Ao cadastrar seu imóvel no Mellro você tem vantagens que jamais imaginou!',
            dialog1: ' Gerenciamento automatico Gratuito',
            dialog2: 'Com boleto e recibo automático',
            dialog3: 'Contrato com assinatura eletronica gratuita',
            dialog4: 'Sem taxas Sem Comissão Sem Surpresa',
          },
          ownersObligation: {
            title: 'OBRIGAÇÕES DO DONO DO IMÓVEL',
            dialog1: 'O valor do Caução retorna para o Morador no final do contrato',
            dialog2:
              'O Dono do imóvel é responsável por executar a cobrança dosvalores mensais.' +
              'Mas não se preocupe você será lembrado  pelo sistema de gerenciamento Mellro',
            dialog3:
              ' Oferecemos uma ferramenta de avaliação de crédito, porém não damos a garantia oferecida',
          },
          finalValue: {
            title: 'VALOR FINAL',
            subtitle:
              'O Valor final do seu anúncio é exatamente o que você definiu durante a criação do anúncio.',
            rentValue: 'Valor do aluguel',
          },
        },
        insuranceBond: {
          subtitle:
            'Uma das preocupações como dono do imóvel é ter segurança' +
            'de recebimento e achar um bom inquilino. ' +
            'Com o seguro fiança essa preocupação não existe mais, ' +
            'pois basta você escolher a opção de seguro fiança embutido ' +
            'e iremos adicionar 15% no valor do aluguel para ser pago pelo inquilino',
          cover: 'COBERTURA',
          guarantee: 'meses garantidos',
          rent: 'Aluguel',
          condominium: 'Condominio',
          iptu: 'IPTU',
          water: 'Agua',
          light: 'Luz',
          gas: 'Gás',
          assistance: 'Assistência',
          Keyring: 'Chaveiro',
          Electrician: 'Eletricista',
          Plumber: 'Encanador',
          whiteLine: 'Linha Branca',
          mellroAdvantages: {
            subtitle: 'Ao cadastrar seu imóvel no Mellro você tem vantagens que jamais imaginou!',
            dialog1: 'Gerenciamento automático Gratuito',
            dialog2: 'Com boleto e recubo automático',
            dialog3: 'Contrato com assinatura eletronica gratuita',
            dialog4: 'Sem taxas Sem Comissão Sem Surpresa',
          },
          residentBenefits: {
            title: 'VANTAGENS PARA O MORADOR',
            dialog1: 'Fim do constrangimento na procura de um fiador',
            dialog2: 'O seguro pode ser pago em parcelas',
            dialog3: 'Assistência 24 horas para reparos emergênciais',
            dialog4: 'Desconto no transporte de sua mudança com transportadoras filiadas',
          },
          propertyOwnerBenefits: {
            title: 'VANTAGENS PARA O DONO DO IMÓVEL',
            dialog1: 'Fim do risco da contratação de Fiadores profissionais',
            dialog2: 'Desobrigação do Fiador tradicional',
            dialog3: 'Garantia de locação atéa entrega das chaves (mediante renovações sucessivas)',
            dialog4:
              'Certeza de cumprimento integral de locação, ou seja, pagamento de aluguel, encargos' +
              '(Condomínio, água, luz, IPTU e gás canalizado), ' +
              'anos ao imóvel, multas contratuais e pintura intera e externa.',
            dialog5: 'Análise prévia do Inquilino',
            dialog6: 'Assistência jurídica gratuíta',
            dialog7: 'Garantia de renovação automática',
            dialog8: 'Boleto gerado automáticamente',
          },
          additionalValues: {
            title: 'VALORES ADICIONAIS',
            subtitle:
              'Os Valores adicinados ao contratar o Seguro Fiança serão pagos pelo Inquilino ' +
              'e não pelo Dono do imóvel e irão alterar o valor final do seu anúncio',
            rentValue: 'Valor do aluguel',
            suretyRate: 'Taxa Seguro Fiança Inclusa',
          },
        },
      },
    },
    reviewProperty: {
      buttonText: {
        buttonTextConfirm: 'Confirmar e Publicar',
      },
      errorText: 'Ocorreu um erro durante a criação do anúncio. ',
    },
  },
  help: {
    titleText: 'Ajuda',
    subtitleText: 'Precisa de alguma ajuda? Encontrou algum problema? Conversa com a gente :)',
    dropdownLabel: 'Escolha um assunto',
    dropdownText: {
      technicalProblemsText: 'Problemas Técnicos',
      questionsText: 'Dúvidas',
      criticismText: 'Críticas',
      suggestionsText: 'Sugestões',
      othersText: 'Outros',
    },
    textAreaPlaceholder: 'Escreva aqui o motivo do seu contato',
    subjectAndBodyRequired: 'O assunto e o corpo da mensagem são obrigatórios.',
    contact: 'Entrar em contato',
    buttonText: 'Enviar',
  },
  login: {
    forgotPassword: {
      forgotText: 'forgotPassword',
      passwordNotFound: {
        notFoundFirstText: 'O email informado não pertence a uma conta do mellro',
        notFoundSecondText: 'Por favor verifique seu email e tente novamente',
      },
      passwordNotSet: {
        notSetFirstText: 'Essa conta foi criada com facebook e não possui senha definida',
        notSetSecondText: 'Basta fazer login com o facebook para acessá-la',
      },
      passwordTimeout: {
        timeOutFirstText: 'Um novo pedido de senha já foi feito para o email informado',
        timeOutSecondText: 'Por favor espere 24 horas e tente novamente',
      },
      logoText: 'mellro',
      recoverPassword: 'Recuperar Senha',
      subheadline: 'Informe seu email para enviarmos uma nova senha',
      askforNewPassword: 'Solicitar Nova Senha',
      doneEmailText:
        'Enviamos a nova senha para o email acima. Por favor verifique sua caixa de entrada.',
      doneChangePassword:
        'Após entrar no aplicativo novamente, sugerimos que altere sua senha o quanto antes.',
      doneBackToLogin: 'Voltar para a tela de login',
    },
    signIn: {
      header: 'Entrar',
      logoText: 'mellro',
      welcomeText: 'Bem vindo de volta!',
      email: 'Email',
      password: 'Senha',
      buttonText: 'Entrar',
      forgotPassword: 'Esqueci minha senha',
      signUpText: 'Ainda não tem conta?',
      signUpLink: 'Crie uma aqui!',
    },
    signUp: {
      header: 'Criar Conta',
      validationMessages: {
        passwordLength: 'A Senha deve ter no mínimo 8 caracteres.',
        passwordConfirm: 'A Senha e Confirmação de Senha não são iguais',
        emailConfirm: 'Já existe uma conta com o email informado',
      },
      labels: {
        name: 'Nome Completo',
        email: 'Email',
        cpf: 'CPF',
        password: 'Senha',
        confirmPassword: 'Confirmar Senha',
      },
      logoText: 'mellro',
      createYourAcc: 'Crie sua conta!',
      subheadline: 'Cadastre-se para anunciar e achar seu imóvel para alugar. É de graça!',
      buttonRegister: 'Registrar Conta',
    },
    home: {
      carousel: {
        title1: 'Seja bem-vindo',
        text1: 'Anuncie ou encontre seu imóvel para alugar',
        title2: 'Encontre um lugar para chamar de seu',
        text2: 'Alugue um novo lar. Do seu jeito. Ah sim! É de graça, viu?',
        title3: 'Anuncie seu imóvel de graça',
        text3: 'Cadastre seu imóvel no Mellro e ache o melhor inquilino!',
        title4: 'Conheça seu inquilino, conheça o proprietário',
        text4: 'No Mellro é fácil conhecer um ao outro e fechar negócio!',
      },
      email: 'Entrar com Email',
      facebook: 'Entrar com Facebook',
      facebookLoginIssue:
        'Nós tentamos comunicar com o Facebook mas não houve resposta. ' +
        'Os serviços deles talvez possam estar indisponíveis, portanto por favor tente mais tarde ' +
        'e desculpe-nos pela inconveniencia.',
      privacyPolicyText: 'Ao logar no Mellro você concorda com os',
      privacyPolicyLink: 'Termos de Privacidade',
    },
  },
  onboarding: {
    location: {
      headerText: 'Permitir Usar Localização',
      subheaderText: 'Você precisa compartilhar sua localização para mostrarmos no mapa.',
      discoverProperty: 'Descubra imóveis próximos',
      yourLocation: 'Sua localização será utilizada para encontrar imóveis próximos a você.',
      footerTitle: 'Descubra imóveis próximos',
      footerText: 'Sua localização será utilizada para encontrar imóveis próximos a você.',
    },
    phoneValidation: {
      description: 'Insira seu número de celular',
      formPlaceholder: 'DDD + Número',
      invalidNumber: 'O número de telefone está incompleto/inválido.',
      pinGenerationError:
        'Ocorreu um erro na geração do código. Por favor confira sua conexão com a internet e ' +
        'tente novamente em alguns instantes.',
      proceedButton: 'Gerar Código',
    },
    pinValidation: {
      description: 'Por favor insira o código recebido via SMS',
      formPlaceholder: 'Insira o código recebido',
      pinValidationError: 'O PIN informado é inválido. Tentativas restantes hoje: {{remaining}}',
      pinValidationException:
        'Não foi possível validar o PIN informado nesse momento. Por favor confira sua conexão ' +
        'com a internet e tente novamente em alguns instantes.',
      resendButton: 'Reenviar Código',
      timeout: '(Disponível em {{resendTimeout}} segundos)',
      proceedButton: 'Validar Código',
    },
    whatYouLookFor: {
      header: {
        titleText: 'O que você procura?',
        subtitleText:
          'Encontre seu novo lar para alugar OU encontre o morador ideal para seu imóvel. ' +
          'Negocie e feche um negócio.',
      },
      wantToRent: {
        title: 'Quero achar o lugar ideal para alugar',
        button: 'Encontrar imóveis',
      },
      wantToAnnounce: {
        title: 'Quero anunciar o meu imóvel',
        button: 'Anunciar meu imóvel',
      },
    },
  },
  profile: {
    email: {
      verifiedHeader: 'E-mail Verificado',
      verified: 'Seu e-mail foi verificado com sucesso!',
      continueToProfile: 'Continuar para o meu Perfil',
    },
    main: {
      bankDetails: 'Dados Bancários',
      bankTitle: 'Dados para Depósito',
      bankSubtitle: 'Informe os dados da conta bancária para receber valores',
      bank: 'Banco',
      branch: 'Agência',
      cpfTitle: 'Cadastrar CPF',
      cpfSubtitle: 'Esta informação é necessária para iniciar negociações e contratos',
      negotiationCPFRegister:
        'Para iniciar a negociação com o dono do imóvel, vamos precisar do seu CPF cadastrado',
      comingSoon: 'Em Breve',
      whatsappNumber: '(Número do Whatsapp)',
      tabs: {
        profile: 'Perfil',
        settings: 'Configurações',
      },
      socialMedia: 'Redes Sociais',
      socialMediaSubtitle: 'Confira as suas principais redes sociais',
      locationDenied:
        'A permissão para o uso de localização foi negada. ' +
        'Para ver a sua localização e a de outros, acesse as preferências do sistema e habilite essa permissão.',
      updatePhotoError: 'Não foi possível atualizar a foto. Por favor tente novamente mais tarde.',
      stateError: 'O número de telefone está incompleto/inválido.',
      errorText: 'Ocorreu um erro durante a mudança do número de whatsapp.',
      dialogInputTitle: 'Digite o número do seu whatsapp com DDD',
      announcementList: 'Lista de Anúncios',
      savedList: 'Lista de Curtidos',
      configurationText: 'Configurações',
      contact: 'Contato',
      resetPassword: 'Redefinir Senha',
      exitText: 'Sair',
    },
    bank: {
      errors: {
        invalidData: 'Dados bancários invalidos!',
      },
      bankTitle: 'Dados para depósito',
      bankSubtitle: 'Informe os dados da sua conta bancária',
      bank: 'Banco',
      branch: 'Agencia',
      accountType: 'Tipo da conta',
      accountNumber: 'N° da conta',
      checkingAccount: 'Conta Corrente',
      savingsAccount: 'Conta Poupança',
      validationMessages: {
        branchNumberLength: 'O número da agência deve conter no máximo 4 carecteres.',
        missingAccountDigit: 'Inclua traço (-) para separar o dígito de conta.',
        invalidAccountDigit: 'Deve haver apenas um dígito de conta.',
      },
      bankPlaceholder: 'Insira o nome do seu banco',
      emptyResult: 'Nenhum resultado encontrado.',
    },
    cpf: {
      invalidCpf: 'CPF inválido',
      cpf: 'CPF',
      cpfTitle: 'Cadastrar CPF',
      cpfSubtitle: 'O CPF é necessário para fazer negociações, avaliações de crédito e contratos.',
      validationMessages: {
        cpfLength: 'O CPF deve ter 11 caracteres.',
      },
      saveAndContinue: 'Salvar e Continuar',
    },
    resetPassword: {
      passwordMinimalCharacters: 'A Senha deve ter no mínimo 8 caracteres.',
      passwordConfirmText: 'A Senha e Confirmação de Senha não são iguais.',
      cantChangePassword:
        'Não foi possível alterar sua senha. Por favor, tente novamente mais tarde.',
      header: {
        headline: 'Redefinir Senha',
        subheadLine: 'Por favor insira sua nova senha com no mínimo 8 caracteres.',
      },
      labels: {
        password: 'Senha',
        confirmPassword: 'Confirmar Senha',
      },
      resetPassword: 'Redefinir Senha',
      successChange: 'Senha alterada com sucesso!',
    },
    announcementList: {
      header: {
        titleText: 'Meus anúncios',
        subtitleText: 'Aqui você encontra uma lista com os seus imóveis anúnciados.',
      },
      errorText: 'Ocorreu um erro durante a listagem de anúncios. ',
      emptyListText: 'Você ainda não anunciou nenhum imóvel.',
      editAnnouncement: {
        errorText: 'Ocorreu um erro durante a edição do anúncio. ',
        confirmChanges: 'Confirmar Alterações',
        buttonText: 'Salvar Alterações',
      },
      announcementItem: {
        seeAnnouncement: 'pessoas visualizaram esse anuncio',
        condominiumAndOthers: 'Condominio & Outros',
        deleteAnnoucement: 'Deletar anúncio',
        editAnnouncement: 'Editar anúncio',
        deleteAnnouncementAlert:
          'Você está prestes a apagar o anúncio em {{address}}. Deseja continuar?',
        visibilityText: 'Anúncio Visível',
        interestedText: 'Interessados',
        helper: {
          title: 'Aprovar ou deletar',
          content: 'Ao aprovar este morador você enviará uma proposta',
        },
      },
      notifications: {
        evaluationCredit: {
          headerNavigation: 'Avaliação de Crédito',
          headerText: 'Estamos avaliando seu crédito',
          contentText: 'Em breve você receberá uma notificação informando sobre esse processo',
          buttonText: 'Ver proposta',
        },
        profile: {
          headerNavigation: 'Foto de Perfil',
          headerText: 'Escolha uma foto para o seu perfil',
          contentText:
            'Ao adicionar uma imagem de perfil você aumenta as suas chances de alugar um imóvel!',
          buttonText: 'Selecionar Agora',
        },
        cellphone: {
          headerNavigation: 'Cadastrar Celular',
          headerText: 'Você ainda não possui um celular cadastrado!',
          contentText: 'Para fazer negociações é necessário cadastrar seu celular',
          buttonText: 'Cadastrar Agora',
        },
        interestPeople: {
          headerNavigation: 'Visualização de Anúncio',
          headerText: 'Pessoas viram o seu anúncio!',
          headerSubTitle: 'Seu anúncio parece estar chamando bastante a atenção!',
          contentText: 'Pessoas estão interessadas no seu imóvel!',
          buttonText: 'Visualizar Interessados',
        },
        privateCreditApproved: {
          headerNavigation: 'Avaliação de Crédito',
          headerText: 'Crédito Aprovado',
          subHeaderText: 'Crédito Aprovado de',
          contentText: 'Agora você pode finalizar a negociação com o Dono do Imóvel',
          buttonText: 'Ver proposta',
        },
        proposeAcepted: {
          headerNavigation: 'Contra Proposta',
          headerText: 'Sua contraproposta foi aceita',
          subtitleContent: 'aceitou a sua proposta',
          contentText: 'Agora é sós aguardar',
          contentComplement: 'assinar o contrato',
          buttonText: 'Ver contraproposta',
        },
        counterproposal: {
          headerNavigation: 'Contra Proposta',
          headerText: 'enviou uma contraproposta',
          subtitleContent: 'enviou uma contraproposta para você',
          contentText: 'Você pode avaliar agora, aceitar, recusar ou encaminhar uma nova proposta!',
          buttonText: 'Ver contraproposta',
        },
      },
    },
    announcementMatch: {
      matchItem: {
        abandonTenantText:
          'Você está prestes a abandonar o interesse no inquilino {{tenantName}} ' +
          'para o seu imóvel em {{address}}. ' +
          'Deseja continuar?',
        closeDeal: 'Fechar Negócio',
        contactTenant: 'Contatar Inquilino!',
        likeProfile: 'Você curtiu esse perfil!',
        deleteTenant: 'Excluir Inquilino',
        verifiedProfile: 'Perfil verificado',
        restore: 'Restaurar interessado',
        dropout: '{{name}} desistiu da negociação!',
      },
      matchList: {
        header: 'Interessados',
        interestedSubtitle:
          'Aqui você encontra uma lista com os interessados que curtiram esse imóvel ' +
          'e estão aguardando sua resposta.',
        refusedSubtitle:
          'Aqui você encontra uma lista com as pessoas que gostaram desse imóvel ' +
          'mas que você recusou.',
        dropoutSubtitle:
          'Aqui você encontra uma lista com as pessoas que curtiram esse imóvel mas ' +
          'desistiram antes que você as respondesse.',
        error: 'Ocorreu um erro na listagem/resposta de interessados nesse anúncio. ',
        emptyLike: 'Esse imóvel ainda não recebeu curtidas.',
      },
      state: {
        matched: 'Perfil Aprovado',
        waiting: 'Aguardando Aprovação',
        refused: 'Perfil Recusado',
        dropout: 'Perfil Desistente',
      },
      tabs: {
        refused: 'Recusados',
        interested: 'Interessados',
        dropouts: 'Desistentes',
      },
      helper: `Nós enviamos uma proposta para {{name}} baseada nas suas condições!
      \n Você pode alterar a qualquer momento`,
    },
    saved: {
      header: 'Curtidas',
      titleText: 'Curtidos',
      subtitleText: 'Confira os Imóveis que você curtiu durante sua busca no Catalogo do Mellro.',
      errorText: 'Ocorreu um erro durante a listagem de curtidos.',
      emptySavedAnnouncements: 'Nenhum anúncio curtido',
      savedList: {
        header: {
          headerTitle: 'Liked',
          headerSubTitle: 'Todos os imóveis que você curtiu estão aqui!',
        },
        errorText: 'Ocorreu um erro durante a listagem de curtidos. ',
        noLikedProperties: 'Você ainda não curtiu nenhum imóvel.',
        noDislikedProperties: 'Você ainda não descartou nenhum imóvel.',
      },
      savedItem: {
        informationText: 'Informação',
        viewTheTenant:
          'Ver o perfil de inquilino somente é possível quando você for aprovado por ele',
        undoAlertText:
          'Você está prestes a desfazer o interesse no imóvel em {{address}}. ' +
          'Deseja Continuar?',
        abandonAlertText:
          'Você está prestes a abandonar o interesse no imóvel em {{address}}. ' +
          'Deseja Continuar?',
        closeDealText: 'Fechar Negócio',
        contactTenant: 'Contatar Locador!',
        approvedText: 'Seu perfil foi curtido de volta!',
        abandonProperty: 'Discartar Imóvel',
        waitForApproval: 'Aguardando Aprovação',
        waitingOwnerApproval: 'Estamos aguardando a aprovação do dono do imóvel',
        undoInterest: 'Desfazer Interesse',
        goToAnnouncementDetails: 'Conferir Detalhes do Imóvel',
        approved: 'Perfil Aprovado',
        viewProfile: 'Ver Perfil do Locador',
        condominiumAndOthers: 'Condomínio & Outros',
      },
      dislikedItem: {
        restore: 'Restaurar imóvel',
      },
      tab: {
        saved: 'Curtidos',
        discarded: 'Descartados',
      },
    },
    userAnnouncement: {
      titleText: 'Meus anúncios',
      subtitleText: 'Confira os seus imóveis anunciados para aluguel.',
      errorText: 'Ocorreu um erro durante a listagem dos seus anúncios.',
      emptyAnnouncement: 'Nenhum anúncio seu',
    },
    negotiation: {
      titleText: 'Condições do contrato',
      subtitle: 'Defina suas condições para o contrato de locação do seu imóvel',
      receivedProposal: {
        title: 'Proposta recebida',
        content:
          'Você recebeu uma proposta de {{name}} e você pode aceitar ou mandar uma nova proposta',
      },
      status: {
        approved: {
          header: 'Proposta aprovada',
          message: '{{name}} aprovou a sua proposta, agora é só fechar e assinar o contrato',
        },
        returned: {
          header: 'Contra proposta',
          message: '{{name}} fez uma contra proposta',
        },
        declined: {
          header: 'Crédito negado',
          message: '{{name}} teve o crédito recusado para esta proposta',
        },
        pending: {
          header: 'Avalição de crédito pendente',
          message: 'Estamos aguardando o resulado da avaliação de crédito de {{name}}',
        },
        sentProposal: {
          header: 'Proposta enviada',
          message: `Você enviou a proposta anunciada para {{name}}
           e estamos esperando uma resposta. Você pode mudar a proposta quando quiser`,
        },
        counterProposal: {
          received: {
            header: 'Contraproposta recebida',
            message: `Você recebeu uma contraproposta de {{name}}.
            Você pode aceitá-la ou enviar uma nova proposta`,
          },
          sent: {
            header: 'Contraproposta enviada',
            message: `Você enviou uma contraproposta para {{name}}, e nós estamos aguardando a resposta.
            você pode mudar a proposta a qualquer momento`,
          },
        },
        counterProposalSent: `Você enviou uma contraproposta para {{name}}
        e estamos esperando a resposta. Você pode mudar a proposta quando quiser.`,
      },
      warrantyTexts: {
        noGuarantorNeeded: 'Não precisa de fiador',
        boletoPayment: 'Pagamento com boleto',
      },
      conditions: {
        valuesAndMaturitiy: {
          title: 'Valores e vencimentos',
          description: 'Todos os valores e vencimentos você pode conferir aqui',
          changeValue: 'Mudar valor',
        },
        itemsValue: 'Aluguel + Condomínio + IPTU + Outros',
        dueDate: {
          title: 'Vencimento do aluguel',
          content: {
            withDate: 'Vencimento dia {{number}}',
            withoutDate: '{{number}} dias após assinatura',
          },
          changeDueDate: 'Mudar vencimento',
          confirm: 'Confirme Vencimento',
          define: 'Definir vencimento do condomínio',
          save: 'Salvar vencimento',
        },
        paymentAndWarranty: {
          title: 'Modelo de garantia e pagamento',
          content: 'Somente você pode alterar seu modelo de garantia e pagamento',
          changeWarranty: 'Alterar garantia',
        },
      },
      contract: {
        duration: {
          title: 'Duração de contrato',
          content:
            'Renovação automática e reajuste anual pelo IGPM. Multa de 10% do valor restante da duração',
          time: '{{number}}\nAno',
        },
        contract: 'Prosseguir para contrato',
        newProposal: 'Mandar nova proposta',
      },
    },
    registerCPF: {
      titleText: 'Cadastrar CPF',
      registerPage: {
        titleText: 'Cadastrar seu cpf',
        content:
          'Para iniciar a negociação com os interessados vamos precisar do seu CPF cadastrado!',
        buttonLabel: 'Cadastrar agora',
      },
      validationMessages: {
        length: 'CPF Inválido',
      },
    },
    dueDate: {
      titleText: 'Vencimento',
    },
    creditEvaluation: {
      ownerView: {
        approved: '{{name}} teve o crédito aprovado para esta proposta',
        denied: '{{name}} teve o crédito recusado para esta proposta',
        evaluating: 'Estamos avaliando o crédito de {{name}} para esta proposta',
        pending: 'Estamos aguardando {{name}} informar seu CPF para avliação de crédito',
      },
      tenantView: {
        denied: {
          title: 'Crédito reprovado',
          message:
            'Sua avaliação de crédito não foi aprovada! Converse com {{name}} para renegociar',
        },
      },
    },
    settings: {
      header: {
        headline: 'Alterar Senha',
        subheadLine: 'Mude sua senha de acesso',
      },
      currentPasswordDisclaimer:
        'A Senha atual é obrigatória somente se você criou sua conta sem usar ' +
        'o login com facebook ou se já definiu uma senha anteriormente.',
      labels: {
        currentPassword: 'Senha atual',
        newPassword: 'Nova senha',
        confirmPassword: 'Confirmar nova senha',
      },
      placeholders: {
        currentPassword: 'Insira sua senha aqui',
        newPassword: 'Insira a nova senha aqui',
        confirmPassword: 'Repita a nova senha aqui',
      },
      errors: {
        cantChangePassword:
          'Não foi possível alterar sua senha. Por favor confira se você precisa informar ' +
          ' a senha atual e se a mesma foi digitada corretamente e tente novamente.',
      },
      formValidations: {
        passwordConfirmText: 'A Senha e Confirmação de Senha não são iguais',
        passwordMinimalCharacters: 'Todas as senha devem ter no mínimo 8 caracteres.',
      },
      notifications: {
        header: {
          headline: 'Opções de notificações',
          subheadLine: 'Selecione suas opções no menu abaixo',
        },
        labels: {
          push: 'Push',
          email: 'E-mail',
          submit: 'Salvar alterações',
        },
        errors: {
          settingsUnchanged: 'Não há alterações nas notificações para salvar',
          cantUpdateNotifications:
            'Suas configurações de notificação não foram salvas. Tente novamente mais tarde.',
        },
        successSave: 'Preferências de notificação salvas com sucesso!',
      },
    },
  },
  manage: {
    notifications: {
      payment: {
        paid: {
          title: 'Aluguel do mês de {{month}} pago',
          topText: '{{name}} pagou o aluguel do mês de {{month}}',
          bottomText:
            'Já conferimos em nossos sistema o depósito do boleto ' +
            'e vamos repassar em até 24hs para sua conta bancária!',
          button: 'Visualizar pagamento',
        },
        confirmed: {
          title: 'Aluguel do mês de {{month}} pago',
          automatic: {
            topText: 'Seu pagamento foi efetuado com sucesso!',
            bottomText: 'Nosso sistema detectou seu pagamento!',
          },
          manual: {
            topText: '{{owner}} confirmou o pagamento do aluguel!',
            bottomText:
              'Para visualizar o comprovante e confirmar o pagamento basta administrar o pagamento!',
          },
          button: 'Ver pagamento',
        },
        late: {
          title: 'Aluguel do mês de {{month}} atrasado',
          landlord: {
            topText: '{{name}} atrasou em {{days}} dias útes o pagamento do aluguel de {{month}}!',
            bottomText:
              'Já enviamos uma notificação para {{name}} a respeito deste atraso com o valor recalculado!',
            automatic: 'Caso não seja pago em 20 dias acionaremos o Seguro Fiança automaticamente!',
            manual: '',
            button: 'Visualizar fatura',
          },
          tenant: {
            topText:
              '{{name}}, você atrasou em {{days}} dias útes o pagamento do aluguel de {{month}}!',
            bottomText: 'Já enviamos uma notificação para {{owner}} a respeito deste atraso!',
            automatic: 'Caso não seja pago em 20 dias acionaremos o Seguro Fiança automaticamente!',
            manual: 'Você pode gerar um boleto com o valor recalculado abaixo!',
            button: 'Ver parcela',
          },
        },
        close: {
          title: 'Aluguel do mês de {{month}} está próximo',
          topText: 'O Aluguel de {{month}} está perto da data de vencimento: {{date}}',
          bottomText: 'Mantenha seus pagamentos em dia!',
          button: 'Ver pagamento',
        },
        denied: {
          title: 'Pagamento não confirmado',
          topText: '{{owner}} recusou o seu pagamento!',
          bottomText: 'Envie o comprobante de pagamento novamente!',
          button: 'Ir para a parcela',
        },
      },
      securityDeposit: {
        paid: {
          title: 'Depósito do Caução foi efetuado!',
          topText: '{{name}} afirma que pagou o Caução! ',
          bottomText: 'Confirme o pagamento de {{name}}! ',
          button: 'Confirmar pagamento',
        },
        denied: {
          title: 'Ainda não identificaos o depósito do caução',
          bottomText: 'Para a entrega das chaves é necessário o depósito do Caução!',
          button: 'Confirmar deposito',
        },
        entry: 'Caução de entrada',
        number: {
          title: 'Número de cauções',
          content: 'Selecione quantos cauções equivalem ao valor do aluguel',
          options: {
            withSingleSecurityDeposit: '1 mês - R$ {{value}}',
            withSecurityDeposit: '{{number}} meses - R$ {{value}}',
            withoutSecurityDeposit: 'Sem Caução',
          },
        },
        confirm: 'Confirmar e continuar',
      },
    },
    title: 'Administrar',
    subtitleText: 'Acompanhe pagamentos, faça cobranças.',
    checkOut: 'Acompanhe',
    inactiveMonth: 'Contrato inativo neste mês!',
    payment: {
      state: {
        paid: 'Pago',
        open: 'Em Aberto',
        late: 'Em Atraso',
      },
      name: {
        rent: 'Aluguel',
        condo: 'Condomínio',
        iptu: 'IPTU',
        others: 'Outros',
      },
      info: {
        paidOn: 'Pago em: {{date}}',
        nextDue: 'Próximo vencimento: {{date}}',
        paymentMode: 'Modo de pagamento: ',
        paymentModeValue: {
          money: 'Em Dinheiro',
        },
        discount: 'Desconto de:',
      },
      discount: {
        title: 'Valor do Desconto',
        text: 'Você vai dar esse desconto na próxima parcela!',
        valuePlaceholder: 'Insira o valor do desconto',
        reasonPlaceholder: 'Insira um motivo para a nova condição',
        warning: {
          greaterThanZero: 'O disconto deve ser maior que zero!',
          lessThanPrice: 'O disconto deve ser no máximo {{price}}',
        },
      },
      lateWarning: {
        title: 'Itens em atraso!',
        text: 'Enviamos diariamente uma notificação para {{name}}',
      },
      buttons: {
        discount: 'Disconto no valor',
        applyDiscount: 'Aplicar disconto',
        checkVoucher: 'Visualizar comprovante',
        approvePayment: 'Confirmar pagamento',
        discardPayment: 'Descartar pagamento',
        undoApproval: 'Desfazer aprovação',
        paymentApproved: 'Pagamento aprovado',
        download: 'Baixar Boleto',
        sendToEmail: 'Enviar para e-mail',
        copyCode: 'Copiar código do boleto',
        paid: 'Já paguei',
        sendVoucher: 'Enviar comprovante',
      },
      voucher: 'Comprovante',
    },
  },
  rent: {
    details: {
      savedText:
        'Você adicionou este anúncio a sua lista de Curtidos! \n' +
        'Agora é só esperar a aprovação do dono para continuar.',
      textButton: 'Voltar para o Catálogo',
    },
    filters: {
      header: 'Filtros',
      discardedSection: {
        title: 'Propriedades descartadas',
        text:
          'Quando você descarta uma propriedade, ela vai para a sua lista de propriedades descartadas. Mas não' +
          'se preocupe, você pode restaurá-las!',
        button: 'Restaurar Propriedades descartadas',
      },
      locationSection: {
        title: 'Localização',
        text:
          'Encontre os imóvel dos seus sonhos buscando por endereço, cidade, bairro ou diretamente no mapa.',
        subtitle: 'Buscar por Endereço',
        autocomplete: 'Insira o Bairro, Cidade, ou Endereço',
      },
      petSection: {
        title: 'Política com Animais',
        allowed: 'Permitido',
        indifferent: 'Não faz diferença',
      },
      sectionTitle: 'Localização',
      valuesText: 'Valores',
      rentValueText: 'Valor do Aluguel',
      rentValue: 'entre {{min}} e {{max}}',
      valueType: {
        rent: 'Aluguel',
        total: 'Total',
      },
      distance: 'Distância máxima - {{distance}}km',
      minimalValue: 'Valor Mínimo',
      maxValue: 'Máximo',
      propertyInformation: {
        alertText:
          'A permissão para o uso de localização foi negada. ' +
          'Para usar o filtro de proximidade, acesse as preferências do sistema e habilite essa permissão.',
        propertyInformationText: 'Informações do imóvel',
        roomText: 'Quarto(s)',
        bathroomText: 'Banheiro(s)',
        carSlotsText: 'Vaga(s)',
        dontMatterText: 'Não importa',
      },
      totalArea: 'Área total do Imóvel',
      totalAreaValue: 'entre {{min}}m2 e {{max}}m2',
      propertyDetail: 'Detalhes do imóvel',
      condominiumDetail: 'Detalhes do condomínio',
      resetFilters: 'Limpar Filtros',
      textButton: 'Aplicar Filtros',
      propertyTypes: 'Tipos de Imóvel',
    },
    catalog: {
      header: 'Alugar',
      filters: 'Filtros',
      liked: 'Curtidos',
      undo: 'Desfazer',
      tabs: {
        map: 'Mapa',
        list: 'Lista',
        cards: 'Cartões',
      },
      emptyDeck: {
        noMatchText: 'Desculpe, não foi possível encontrar nenhum imóvel no momento.',
        notificationAlert:
          'Você será alertado em suas notificações quando imóveis com as características que deseja ' +
          'aparecerem em seu radar de busca',
        changeFilters: 'Alterar filtros',
        undoDiscard: 'Restaurar imóveis descartados',
        noMatchTryAgain:
          'Experimente limpar/mudar os filtros atuais e se ainda não houver resultados, ' +
          'você pode restaurar os imóveis que você descartou anteriormente.',
        cleanFilters: 'Limpar Filtros',
      },
      cards: {
        additionalTaxes: 'Condomínio & Outros',
        info: {
          house: 'Casa',
          apartment: 'Apê',
          studio: 'Studio',
          type: 'Tipo',
          area: 'Área',
          bathrooms: 'Banheiros',
          rooms: 'Quartos',
          carSlots: 'Garagem',
          details: '+ Detalhes',
        },
      },
      map: {
        alertText:
          'A permissão para o uso de localização foi negada. Para melhorar sua experência ' +
          'do mapa de catálogo, acesse as preferências do sistema e habilite essa permissão.',
      },
    },
    notifications: {
      header: 'Notificações',
      tabs: {
        recent: 'Recentes',
        properties: 'Imóveis',
        like: 'Curtidas',
      },
      like: {
        title: '{{name}} curtiu o seu imóvel!',
        message: 'Agora você pode pode aprovar ou visualizar o perfil de {{name}}.',
        approveProfile: 'Aprovar Perfil',
      },
      match: {
        landlordTitle: 'Você aprovou {{name}}!',
        tenantTitle: '{{name}} aprovou seu perfil!',
        message: 'Agora você pode pode entrar em contato com {{name}} ou visualizar o seu perfil',
      },
      alreadyRented: {
        title: 'Ah que pena!',
        subtitle: 'O Imóvel de {{name}} já foi alugado!',
        message:
          'Mas não se preocupe, você pode encontrar muitos outros imóveis em nosso catalogo!',
        goToCatalog: 'Ir para o catalogo',
      },
      counterProposal: {
        title: '{{name}} fez uma contraproposta',
        message: '{{name}} encaminhou uma contraproposta pra você!',
        questions: 'Tirar dúvidas',
        seeProposal: 'Ver proposta',
        undoInterest: 'Desfazer Interesse',
      },
      receivedOffer: {
        title: 'Proposta recebida',
        message: '{{name}} aprovou seu perfil e encaminhou uma proposta para você!',
      },
      ownerApprovedProfile: {
        title: '{{name}} aprovou o seu perfil!',
        message: '{{name}} mandou uma proposta e você pode negociar ou tirar dúvidas.',
        questions: 'Tirar dúvidas',
        seeProposal: 'Ver proposta',
        undoInterest: 'Desfazer Interesse',
      },
      undoneInterest: {
        title: '{{name}} desfez o interesse no seu imóvel',
        message:
          'Opa, parece que {{name}} não tem mais interesse no seu imóvel. ' +
          'Sem problemas, outros interessados virão rapidinho, pode ter certeza!',
        seeInterested: 'Undo interest',
      },
      interestedTenant: {
        title: '{{name}} se interessou por seu imóvel',
        title2: '{{name}} está esperando por você',
        message:
          'Agora você pode aprovar o perfil de {{name}}, visualizar seu perfil ou excluir o seu interesse.',
        message2: '{{name}} curtiu seu imóvel ontem e está esperando a sua aprovação!',
        approveProfile: 'Aprovar perfil',
        deleteInterested: 'Excluir interessado',
      },
    },
  },
  contract: {
    header: 'Contrato',
    type: {
      depositBond: 'CAUÇÃO DE ENTRADA',
      insuranceBond: 'SEGURO INCLUSO',
    },
    buttons: {
      readContract: 'Ler Contrato',
      manage: 'Administrar',
      terminateContract: 'Encerrar Contract',
      createContract: 'Criar Contrato',
    },
    contractMain: {
      title: 'Revise o contrato antes de assinar',
      contractParties: 'Partes do contrato',
      signAsLandlord: 'Assina como dono',
      signAsTenant: 'Assina como morador',
      dueDateMonth: '{{dueDate}}/todo mês',
      paymentType: {
        cashPayment: 'PAGAMENTO EM DINHEIRO',
        billPayment: 'PAGAMENTO POR BOLETO',
      },
      negotiatedConditions: {
        title: 'Condições negociadas',
        aboveConditions:
          'Abaixo se encontram todas as condições negociadas e adicionadas ao seu contrato',
        value: 'Cerca de {{value}} mensais',
        landlordPays: 'Pago pelo dono',
      },
      isuranceModel: {
        title: 'Modelo de garantia e pagamento',
        moneyPayment: 'Pagamento em dinheiro',
        billetPayment: 'Pagamento em boleto',
      },
      contractDuration: {
        title: 'Duração do contrato',
        subtitle: 'Renovação automática e reajuste anual pelo',
        subtitle2: 'Multa de 10% do valor restante da duração.',
        bottomText: 'Encaminharemos o contrato assinado para todas as partes!',
        contractDuration: '{{count}} meses',
      },
    },
    notification: {
      header: 'Assinar contrato',
      ready: {
        title: 'Seu contrato está pronto',
        topText: 'Seu contrato de locação está pronto para ser assinado!',
        bottomText:
          'Você receberá um email em breve contendo o contrato de locação para ser assinado digitalmente.',
        button: 'Tirar dúvidas',
      },
      signed: {
        title: 'Todo mundo já assinou!',
        topText: 'Você e {{name}} já assinaram o contrato!',
        bottomText:
          'Agora é só esperar o depósito do caução para entregar as chaves e começar a administrar!',
        button: 'Admministrar',
      },
    },
  },
}
